import axios from 'axios';

const API_BASE_URL = process.env.MCS_USER_BASE_URL;

const config = {
  baseURL: API_BASE_URL,
  withCredentials: true,
};

const API = axios.create(config);

type TokenBySessionResult = {
  token: string;
  expires_at: string;
};

export const getTokenBySession = async () => {
  const { data } = await API.get<TokenBySessionResult>('/me/jwt-token');
  return data;
};
